//TODO why do we need this 🤦‍♂️
import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { RecoilRoot } from "recoil";
import { RecoilDevTools } from "recoil-gear";
import { RecoilURLSyncJSON } from "recoil-sync";

import { theme } from "./src/app-material-theme";
import "./src/pages/index.css";

export const wrapRootElement = ({ element }) => {
  return (
    <RecoilRoot>
      <RecoilDevTools />
      <RecoilURLSyncJSON location={{ part: "queryParams" }}>
        {element}
      </RecoilURLSyncJSON>
    </RecoilRoot>
  );
};
